module.exports = __WEBPACK_EXTERNAL_MODULE_87__;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 87
// module chunks = 0 1